// src/client/components/CreditScoreGauge.tsx
// Simple semicircular gauge: a track (border) and a filled arc whose length
// is `score / 100` of the half-circumference. Tier label sits below.
import type { CreditScoreFixture } from '@client/lib/fixtures';
import styles from './CreditScoreGauge.module.css';

interface Props { score: CreditScoreFixture; }

const RADIUS = 60;
const STROKE = 12;
const HALF_CIRC = Math.PI * RADIUS;

const TIER_LABEL: Record<CreditScoreFixture['tier'], string> = {
  new: 'New',
  building: 'Building',
  established: 'Established',
  strong: 'Strong',
  excellent: 'Excellent',
};

export default function CreditScoreGauge({ score }: Props) {
  const fill = (Math.max(0, Math.min(100, score.score)) / 100) * HALF_CIRC;
  return (
    <div className={styles.wrap}>
      <svg viewBox="0 0 160 90" width="160" height="90" aria-label={`Credit score ${score.score} of 100`} role="img">
        <path
          d={`M 20 80 A ${RADIUS} ${RADIUS} 0 0 1 140 80`}
          stroke="var(--c-border)"
          strokeWidth={STROKE}
          fill="none"
          strokeLinecap="round"
        />
        <path
          d={`M 20 80 A ${RADIUS} ${RADIUS} 0 0 1 140 80`}
          stroke="var(--c-primary-700)"
          strokeWidth={STROKE}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={`${fill} ${HALF_CIRC}`}
        />
      </svg>
      <div className={styles.value} aria-hidden>{score.score}</div>
      <div className={styles.tier} aria-hidden>{TIER_LABEL[score.tier]}</div>
    </div>
  );
}
